// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-empty {\n  display: flex;\n  flex-direction: column; }\n\n.ant-empty-footer > span {\n  font-size: 18px;\n  line-height: 32px;\n  color: #262626; }\n\n.Empty_wrapper__3p_gS.Empty_large__1sNOp .ant-empty-image {\n  min-height: 152px; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "Empty_wrapper__3p_gS",
	"large": "Empty_large__1sNOp"
};
module.exports = exports;
